/**
 * ProvenancePanel - renders a stored report's Provenance_Record by reusing the
 * chat ActivityChips and ActivityTrace. An empty record shows a plain message
 * instead. No live-status line is rendered: every stored entry is terminal.
 *
 * Requirements: 12.5, 12.8
 */
import { ActivityChips } from '@/components/chat/ActivityChips';
import { ActivityTrace } from '@/components/chat/ActivityTrace';
import type { ProvenanceEntry } from '@/types/insights';
import { hasNoCapabilities, provenanceToActivities } from './provenanceAdapter';

export interface ProvenancePanelProps {
  /** The report's persisted provenance, in stored order. */
  provenance: ProvenanceEntry[];
}

export function ProvenancePanel({ provenance }: ProvenancePanelProps) {
  if (hasNoCapabilities(provenance)) {
    return (
      <p className="text-sm text-dark-400" data-testid="provenance-empty">
        No external capabilities were used.
      </p>
    );
  }

  const activities = provenanceToActivities(provenance);

  return (
    <div className="space-y-2" data-testid="provenance-panel">
      <ActivityChips activities={activities} />
      <ActivityTrace activities={activities} />
    </div>
  );
}
